<template>
    <SideBanner class="component" />
    <JackpotSideBanner v-if="isJackpotEnabled" class="component" />
    <SportListBlock class="component" />
    <div v-bind:class="{ sticky: isLayoutExpanded }">
        <BetSlipBlock
            class="component component-float betSlipBlock"
            v-bind:class="{
                show: isBetSlipExpanded,
            }"
        />
        <MiniMyBetsBlock
            class="component component-float"
            v-bind:class="{
                show: isMyBetsExpanded,
                autoGrow: isLayoutExpanded && isMyBetsExpanded,
            }"
        />
    </div>
</template>

<script lang="ts" setup>
    import { storeToRefs } from 'pinia';
    import SideBanner from '@/components/banner/SideBanner.vue';
    import BetSlipBlock from '@/components/betSlip/BetSlipBlock.vue';
    import JackpotSideBanner from '@/components/jackpot/JackpotSideBanner.vue';
    import MiniMyBetsBlock from '@/components/myBets/miniMyBets/MiniMyBetsBlock.vue';
    import SportListBlock from '@/components/sportList/SportListBlock.vue';
    import { SiteStyle } from '@/interface/enum';
    import { useLayoutStore } from '@/store/layoutStore';
    import { useToggleStore } from '@/store/toggleStore';

    const { isBetSlipExpanded, isMyBetsExpanded, isLayoutExpanded } = storeToRefs(useLayoutStore());

    const { isJackpotEnabled } = storeToRefs(useToggleStore(SiteStyle.Asia));
</script>
